export const validation = {
  client: {
    emails: {
      eachTypeSelected: 'Select at least one email address for each type of email',
      noEmptySelection: 'Select at least one type of email per email address',
    },
  },
  dateFuture: 'Choose a date in the future.',
  dateSameOrAfter: '{{attribute}} must be on or after {{after}}.',
  dateTomorrow: 'The expiry date must be tomorrow at the earliest.',
  email: {
    invalid: 'Enter a valid email address.',
  },
  iban: 'Enter a valid account number.',
  integrations: {
    accountantEmailInvalid: 'Your accountant doesn’t have an account on our Credit platform yet.',
  },
  invoice: {
    lines: {
      minimumOne: 'Add at least one invoice line to the invoice.',
      minimumOneNotFree: 'Add at least one invoice line that isn’t free.',
    },
  },
  invoiceTemplate: {
    nextInvoiceTomorrow: 'Your next invoice can be tomorrow at the earliest.',
  },
  max: '{{attribute}} cannot be greater than {{max}}.',
  maxDiscount: 'The discount cannot be greater than the total price.',
  maxFileSize: 'The file cannot be larger than {{max}} MB.',
  maxLength: '{{attribute}} cannot be longer than {{max}} characters.',
  maxLengthInLanguage: '{{attribute}} cannot be longer than {{max}} characters ({{lang}}).',
  min: '{{attribute}} cannot be less than {{min}}.',
  minLength: '{{attribute}} must be longer than {{min}} characters.',
  password: {
    incorrect: 'This password is incorrect.',
    match: 'This password must be exactly the same as the new password.',
  },
  phoneNumber: {
    format: 'Enter a valid phone number.',
    missingCallingCode: 'The phone number must start with a country code, for example +32 for Belgium.',
  },
  quotation: {
    lines: {
      minimumOne: 'Add at least one quotation line to the quotation.',
      minimumOneNotFree: 'Add at least one quotation line that isn’t free.',
    },
  },
  required: 'This field is required.',
  requiredAttribute: '{{attribute}} is required.',
  requiredInLanguage: 'This field is required ({{lang}}).',
  vatNumber: {
    belgianFormat: 'Please enter a valid company number. It consists of 10 digits and starts with 0 or 1.',
    inactive: 'This organization is not active.',
    invalid: 'The VAT number is invalid. Could you look it up again?',
    unique: 'You’ve already created a client with this VAT number. <0>Click here</0> to add a new contact person to this client.',
  },
};
